import React, { Component } from 'react';
import axios from 'axios';
import { Card } from 'antd';

const API_HOST_URL = process.env.REACT_APP_API_URL

class EmployeeDetail extends Component{

  state = {
    employee: {}
  }
   
  componentDidMount(){
      const employeeId = this.props.match.params.employeeId;
      axios.get(`${API_HOST_URL}/api/employee/${employeeId}`)
      .then(res => {
        this.setState({
          employee: res.data
        })

        console.log(res.data);
      })
  }

    render(){
        return(
            <Card title={this.state.employee.firstName}>
                <p>{this.state.employee.lastName}</p>
            </Card>
        );
    }
}

export default EmployeeDetail;
